import { BrowserModule } from '@angular/platform-browser';
import { APP_INITIALIZER, NgModule, Provider } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { SharedModule } from './shared/shared.module';
import { AppRoutingModule } from './app-routing.module';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HttpClient, HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { AppComponent } from './app.component';
import { LoginComponent } from './auth/login/login.component';
import { ToastrModule } from 'ngx-toastr';
import { AdminGuard } from './shared/guard/admin.guard';
import { SecureInnerPagesGuard } from './shared/guard/SecureInnerPagesGuard.guard';
import { CookieService } from 'ngx-cookie-service';
import { JwtConfig, JwtModule, JWT_OPTIONS } from '@auth0/angular-jwt';
import { BlockUIModule } from 'ng-block-ui';
import { ConfigService } from './shared/services/config.service';
import { AuthService } from './shared/services/auth.service';
import 'hammerjs';
import 'mousetrap';
import { GalleryModule } from '@ks89/angular-modal-gallery';
import { CountToModule } from 'angular-count-to';
import { LoadingInterceptor } from './shared/interceptors/loading.interceptor';
import { DefaultUrlSerializer, UrlSerializer, UrlTree } from '@angular/router';
// AoT requires an exported function for factories
export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}


export function tokenGetter() {
  return localStorage.getItem('token');
}

export function jwtConfigFactory(): JwtConfig {
  return {
    tokenGetter,
    allowedDomains: [],
    disallowedRoutes: [],
  }
}

export function jwtInitialiserFactory(configService: ConfigService, jwtConfig: JwtConfig): () => Promise<void> {
  return async () => {
    jwtConfig.allowedDomains.push(configService.testUrl);
    jwtConfig.disallowedRoutes.push(configService.testUrl + '/api/auth');
  };
}

export class LowerCaseUrlSerializer extends DefaultUrlSerializer {
  parse(url: string): UrlTree {
    let urls = url.split('/');
    if (urls.length < 3)
      return super.parse(url);
    else if (urls.length == 3)
      return super.parse(url.toLowerCase());
    else
      return super.parse('/' + urls[1].toLowerCase() + '/' + urls[2].toLowerCase() + '/' + urls[3]);
  }
}

const jwtOptionsProvider: Provider = {
  provide: JWT_OPTIONS,
  useFactory: jwtConfigFactory,
  deps: []
}

const jwtInitialiserProvider: Provider = {
  provide: APP_INITIALIZER,
  useFactory: jwtInitialiserFactory,
  deps: [ConfigService, JWT_OPTIONS],
  multi: true,
}

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
  ],
  imports: [
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    BrowserAnimationsModule,
    SharedModule,
    AppRoutingModule,
    BlockUIModule.forRoot(),
    ToastrModule.forRoot(),
    HttpClientModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      },
    }),
    JwtModule.forRoot({ jwtOptionsProvider }),
    GalleryModule.forRoot(),
    CountToModule
  ],
  providers: [
    AuthService,
    AdminGuard,
    SecureInnerPagesGuard,
    CookieService,
    jwtInitialiserProvider,
    { provide: HTTP_INTERCEPTORS, useClass: LoadingInterceptor, multi: true },
    { provide: UrlSerializer, useClass: LowerCaseUrlSerializer }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
